export const roundMinToLowerZero = (value: number, offset: number = 0): number => {
  if (value === 0) return 0;

  const isNegative = value < 0;
  const absValue = Math.abs(value);
  let rounded: number;

  if (absValue < 1) {
    const magnitude = Math.floor(Math.log10(absValue));
    const factor = Math.pow(10, magnitude);
    rounded = Math.floor(absValue / factor) * factor;
  } else if (absValue < 10) {
    rounded = Math.floor(absValue * 10) / 10;
  } else {
    const magnitude = Math.floor(Math.log10(absValue));
    const factor = Math.pow(10, magnitude);
    rounded = Math.floor(absValue / factor) * factor;
  }

  return isNegative ? -rounded - offset : rounded - offset;
};

export const roundMaxToUpperZero = (value: number, offset: number = 0): number => {
  if (value === 0) return 0;

  const isNegative = value < 0;
  const absValue = Math.abs(value);
  let rounded: number;

  if (absValue < 1) {
    const magnitude = Math.floor(Math.log10(absValue));
    const factor = Math.pow(10, magnitude);
    rounded = Math.ceil(absValue / factor) * factor;
  } else if (absValue < 10) {
    rounded = Math.ceil(absValue * 10) / 10;
  } else {
    const magnitude = Math.floor(Math.log10(absValue));
    const factor = Math.pow(10, magnitude);
    rounded = Math.ceil(absValue / factor) * factor;
  }

  return isNegative ? -rounded + offset : rounded + offset;
};
